export class UsuarioServicioWrapper {

    status: boolean;
    errorMessage: string;
    username: string;
    secret: string;

}
